<template>
  <div class="modal-background" @click="closeModal">
    <div class="modal active" @click.stop>
      <div class="modal-header">
        <h3>{{ modalData.contact_name }}</h3>
        <span class="answered-by">
          answered by {{ modalData.agent_name }} @ {{ formatDate(modalData.date) }}
        </span>
        <button @click="closeModal" class="close-button">&#10005;</button>
        <hr>
      </div>
      <div class="modal-body">
        <div class="chat-container">
          <div v-for="(msg, index) in modalData.messages" :key="index" :class="messageClass(msg.sender)">
            {{ msg.text }}
          </div>
          <div class="system-message1">Conversation was marked resolved by {{ modalData.agent_name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseISO, addHours, format } from 'date-fns';

export default {
  props: {
    modalData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDate(utcDate) {
      const date = parseISO(utcDate);
      const dateInUTC7 = addHours(date, 7);
      return format(dateInUTC7, 'dd/MM/yyyy HH:mm:ss');
    },
    closeModal() {
      this.$emit('close');
    },
    messageClass(sender) {
      return {
        'user-message': sender === 'user',
        'admin-message': sender === 'admin',
        'system-message': sender === 'system',
      };
    },
  },
};
</script>

<style scoped>
.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  background: white;
  padding: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  width: 80%;
  max-width: 600px;
  max-height: 80%;
  overflow-y: auto;
  border-radius: 10px;
}

.modal .modal-header {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
}

.modal .modal-header h3 {
  margin: 0;
  font-size: 24px;
}

.modal .modal-header .answered-by {
  font-size: 16px;
  color: grey;
}

.modal .modal-body {
  font-size: 20px;
}

.chat-container {
  display: flex;
  flex-direction: column;
}

.user-message,
.admin-message,
.system-message,
.system-message1 {
  max-width: 25%;
  padding: 10px;
  margin: 10px;
  border-radius: 10px;
  font-size: 16px;
  position: relative;
  word-wrap: break-word;
}

.user-message {
  align-self: flex-start;
  background-color: #ffefd5;
}

.admin-message {
  align-self: flex-end;
  background-color: #e6e6fa;
}

.system-message {
  max-width: 100%;
  text-align: center;
  align-self: center;
  color: grey;
  background-color: transparent;
}

.system-message1 {
  max-width: 100%;
  text-align: center;
  align-self: center;
  color: grey;
  background-color: #f0f0f0;
}

.user-message:after,
.admin-message:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
}

.user-message:after {
  left: -10px;
  top: 10px;
  border: 10px solid;
  border-color: transparent #ffefd5 transparent transparent;
}

.admin-message:after {
  right: -10px;
  top: 10px;
  border: 10px solid;
  border-color: transparent transparent transparent #e6e6fa;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #666;
}
</style>
